import React, { useState, useEffect, useContext } from 'react';
import {
  AppBar,
  Badge,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Container,
  Grid,
  IconButton,
  Toolbar,
  Typography,
  Button,
  ButtonGroup,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Box,
  TextField,
  Menu,
  Tab,
  Tabs,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Switch,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import {
  ShoppingCart,
  Add as AddIcon,
  Remove as RemoveIcon,
  Warning as WarningIcon,
  Search as SearchIcon,
  Settings as SettingsIcon,
  Block as BlockIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import Constants from './Constants';
import { LanguageCtx, LoginInfo } from '../../App';
import ApiFetch from '../ApiFetch';
import { isLoggin } from '../../service/LoginService';
import i18n from '../../i18n/config';

const Shop = () => {
  async function getCoin(){
      return new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/coin/balance/").then((r)=>{
          return r.json()
      })
  }
  async function getItemList(keyword){
    return new ApiFetch().post(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/item/itemList",{itemName:keyword}).then((r)=>{
        return r.json()
    })
  }
  // State管理
  const [cart, setCart] = useState({});
  const [selectedRating, setSelectedRating] = useState('ALL');
  const [showWarning, setShowWarning] = useState(false);
  const [confirmedRating, setConfirmedRating] = useState('ALL');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [blockedCategories, setBlockedCategories] = useState([]);
  const [itemList, setItemList] = useState([]);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [cartDialogOpen, setCartDialogOpen] = useState(false);
  const [purchaseComplete, setPurchaseComplete] = useState(false);
  const {language,setLanguage} = useContext(LanguageCtx)
  const [coin, setCoin] = useState(0)
  // ログイン情報
  const {loginInfo,setLoginInfo} = useContext(LoginInfo)

  // 定数定義
  const ratings = {
    'ALL': { label: '全年齢', color: 'success' },
    'PG12': { label: 'PG-12', color: 'info' },
    'R15': { label: 'R-15', color: 'warning' },
    'R18': { label: 'R-18', color: 'error' },
    'R18G': { label: 'R-18G', color: 'error' },
  };

  const categories = {
    'all': '全カテゴリー',
    'food': '食品・飲料',
    'goods': 'グッズ',
    'game': 'ゲーム',
    'book': '書籍',
    'anime': 'アニメ',
    'music': '音楽',
  };

  const products = [
    { 
      id: 1, 
      name: 'ファンタジーRPG', 
      price: 8800, 
      image: '/api/placeholder/200/200',
      rating: 'ALL',
      category: 'game',
      description: '誰でも楽しめる王道RPG',
    },
    { 
      id: 2, 
      name: 'ミステリー小説', 
      price: 1500, 
      image: '/api/placeholder/200/200',
      rating: 'PG12',
      category: 'book',
      description: 'ベストセラー作家による最新作',
    },
    { 
      id: 3, 
      name: 'アクションゲーム', 
      price: 7800, 
      image: '/api/placeholder/200/200',
      rating: 'R15',
      category: 'game',
      description: '迫力のバトルシーン',
    },
    { 
      id: 4, 
      name: 'ホラーアニメ', 
      price: 12000, 
      image: '/api/placeholder/200/200',
      rating: 'R18',
      category: 'anime',
      description: '深夜放送の人気シリーズ',
    },
    { 
      id: 5, 
      name: 'サスペンス漫画', 
      price: 680, 
      image: '/api/placeholder/200/200',
      rating: 'R18G',
      category: 'book',
      description: '過激な描写を含む作品',
    },
  ];

  const handlePurchase = () => {
    // 実際のアプリケーションではここで決済処理などを行う
    setPurchaseComplete(true);
    setCart({});
    localStorage.removeItem('cart');
    // 3秒後に購入完了ダイアログを閉じる
    setTimeout(() => {
      setPurchaseComplete(false);
      setCartDialogOpen(false);
    }, 3000);
  };

  useEffect(()=>{
    // ログイン情報取得
    if(loginInfo.length === 0){
        isLoggin().then(json => {
            setLoginInfo(json)
            if(json.result){
                i18n.changeLanguage(json.language)
                setLanguage(json.language)
            } else {
                let s = localStorage
                let l = s.getItem("language")
                if(l !== null){
                    i18n.changeLanguage(l)
                    setLanguage(l)
                    return
                }
                if(window.navigator.language.startsWith("ja")){
                    s.removeItem("language")
                    s.setItem("language","ja")
                    i18n.changeLanguage("ja")
                    setLanguage("ja")
                }  else if(window.navigator.language.startsWith("en")){
                    s.removeItem("language")
                    s.setItem("language","en")
                    i18n.changeLanguage("en")
                    setLanguage("en")
                }
            }
        })
    }
},[loginInfo])

  // LocalStorage からの設定読み込み
  useEffect(() => {
    const savedRating = localStorage.getItem('confirmedRating');
    const savedBlocked = localStorage.getItem('blockedCategories');
    const savedCart = localStorage.getItem('cart');

    if (savedRating) {
      setSelectedRating(savedRating);
      setConfirmedRating(savedRating);
    }
    if (savedBlocked) {
      setBlockedCategories(JSON.parse(savedBlocked));
    }
    if (savedCart) {
      setCart(JSON.parse(savedCart));
    }
  }, []);

  useEffect(() => {
    if(cartDialogOpen && loginInfo.result){
        getCoin().then(r => {
            if(r.result){
                setCoin(r.data.balance)
            }
        })
    }
  }, [loginInfo,cartDialogOpen]);

  useEffect(() => {
    getItemList(searchQuery).then(r => {
        if(r.result){
            setItemList(r.data)
        }
    })
  },[searchQuery])

  // カートの変更を LocalStorage に保存
  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  // カート関連の関数
  const addToCart = (productId) => {
    setCart(prev => ({
      ...prev,
      [productId]: (prev[productId] || 0) + 1
    }));
  };

  const removeFromCart = (productId) => {
    setCart(prev => {
      const newCart = { ...prev };
      if (newCart[productId] > 1) {
        newCart[productId]--;
      } else {
        delete newCart[productId];
      }
      return newCart;
    });
  };

  const getTotalItems = () => {
    return Object.values(cart).reduce((sum, quantity) => sum + quantity, 0);
  };

  const getTotalPrice = () => {
    return Object.entries(cart).reduce((total, [productId, quantity]) => {
      const product = products.find(p => p.id === Number(productId));
      return total + (product.price * quantity);
    }, 0);
  };

  const clearCart = () => {
    setCart({});
  };

  const setCartItemQuantity = (productId, quantity) => {
    setCart(prev => {
      const newCart = { ...prev };
      if (quantity <= 0) {
        delete newCart[productId];
      } else {
        newCart[productId] = quantity;
      }
      return newCart;
    });
  };

  // イベントハンドラ
  const handleRatingChange = (event) => {
    const newRating = event.target.value;
    if (['R18', 'R18G'].includes(newRating) && confirmedRating !== newRating) {
      setSelectedRating(newRating);
      setShowWarning(true);
    } else {
      setSelectedRating(newRating);
      setConfirmedRating(newRating);
      localStorage.setItem('confirmedRating', newRating);
    }
  };

  const handleWarningConfirm = () => {
    setConfirmedRating(selectedRating);
    localStorage.setItem('confirmedRating', selectedRating);
    setShowWarning(false);
  };

  const handleWarningCancel = () => {
    setSelectedRating(confirmedRating);
    setShowWarning(false);
  };

  const handleCategoryChange = (event, newValue) => {
    setSelectedCategory(newValue);
  };

  const handleBlockCategory = (category) => {
    const newBlocked = blockedCategories.includes(category)
      ? blockedCategories.filter(c => c !== category)
      : [...blockedCategories, category];
    setBlockedCategories(newBlocked);
    localStorage.setItem('blockedCategories', JSON.stringify(newBlocked));
  };

  // 商品のフィルタリング
  const filteredProducts = products.filter(product => {
    const ratingPass = Object.keys(ratings).indexOf(product.rating) <= 
                      Object.keys(ratings).indexOf(confirmedRating);
    const categoryPass = selectedCategory === 'all' || product.category === selectedCategory;
    const searchPass = product.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                      product.description.toLowerCase().includes(searchQuery.toLowerCase());
    const notBlocked = !blockedCategories.includes(product.category);
    return ratingPass && categoryPass && searchPass && notBlocked;
  });

  return (
    <>
      <AppBar position="fixed">
        <Toolbar>
          <Typography variant="h6" sx={{ mr: 4 }}>
            <Link to="/" style={{textDecoration:"none",color: "#000000"}}><span className="App-logo d-none d-sm-inline-block" id="logo" style={{fontSize:"18px",cursor:"pointer",color:"#FFFFFF"}}><img src='/img/logo_new_footer.png' height={36} /> Shop</span></Link>
          </Typography>
          
          <Tabs
            value={selectedCategory}
            onChange={handleCategoryChange}
            sx={{ flexGrow: 1 }}
            variant="scrollable"
            scrollButtons="auto"
            textColor="inherit"
            indicatorColor="secondary"
          >
            {Object.entries(categories).map(([key, label]) => (
              <Tab 
                key={key} 
                value={key} 
                label={label}
                disabled={blockedCategories.includes(key)}
              />
            ))}
          </Tabs>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box sx={{ position: 'relative', backgroundColor: 'white', borderRadius: 1 }}>
              <TextField
                size="small"
                placeholder="検索..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                sx={{ width: 200 }}
                InputProps={{
                  startAdornment: <SearchIcon color="action" sx={{ mr: 1 }} />,
                }}
              />
            </Box>

            <IconButton color="inherit" onClick={() => setSettingsOpen(true)}>
              <SettingsIcon />
            </IconButton>

            <IconButton color="inherit" onClick={() => setCartDialogOpen(true)}>
              <Badge badgeContent={getTotalItems()} color="error">
              <ShoppingCart />
              </Badge>
              </IconButton>
            <Typography variant="h6" sx={{ ml: 2 }}>
            ¥{getTotalPrice().toLocaleString()}
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>

      {/* カート確認ダイアログ */}
      <Dialog
        open={cartDialogOpen}
        onClose={() => setCartDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          ショッピングカート
        </DialogTitle>
        <DialogContent>
          {purchaseComplete ? (
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography variant="h6" color="primary" gutterBottom>
                ご購入ありがとうございました！
              </Typography>
              <Typography variant="body1">
                注文の確認メールをお送りいたしました。
              </Typography>
            </Box>
          ) : Object.keys(cart).length > 0 ? (
            <>
              <TableContainer component={Paper} sx={{ mb: 3 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>商品名</TableCell>
                      <TableCell align="right">単価</TableCell>
                      <TableCell align="center">数量</TableCell>
                      <TableCell align="right">小計</TableCell>
                      <TableCell align="center">操作</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Object.entries(cart).map(([productId, quantity]) => {
                      const product = products.find(p => p.id === Number(productId));
                      return (
                        <TableRow key={productId}>
                          <TableCell>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                              <img 
                                src={product.image} 
                                alt={product.name} 
                                style={{ width: 50, height: 50, objectFit: 'cover' }}
                              />
                              <Box>
                                <Typography variant="body1">{product.name}</Typography>
                                <Chip 
                                  label={ratings[product.rating].label}
                                  color={ratings[product.rating].color}
                                  size="small"
                                  sx={{ mt: 1 }}
                                />
                              </Box>
                            </Box>
                          </TableCell>
                          <TableCell align="right">
                            ¥{product.price.toLocaleString()}
                          </TableCell>
                          <TableCell align="center">
                            <ButtonGroup variant="outlined" size="small">
                              <IconButton 
                                onClick={() => removeFromCart(product.id)}
                                size="small"
                              >
                                <RemoveIcon />
                              </IconButton>
                              <Button disabled size="small">
                                {quantity}
                              </Button>
                              <IconButton 
                                onClick={() => addToCart(product.id)}
                                size="small"
                              >
                                <AddIcon />
                              </IconButton>
                            </ButtonGroup>
                          </TableCell>
                          <TableCell align="right">
                            ¥{(product.price * quantity).toLocaleString()}
                          </TableCell>
                          <TableCell align="center">
                            <IconButton
                              onClick={() => setCartItemQuantity(product.id, 0)}
                              color="error"
                              size="small"
                            >
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    <TableRow>
                      <TableCell colSpan={3} align="right" sx={{ fontWeight: 'bold' }}>
                        合計
                      </TableCell>
                      <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                        ¥{getTotalPrice().toLocaleString()}
                      </TableCell>
                      <TableCell />
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Button
                  variant="outlined"
                  color="error"
                  onClick={clearCart}
                  startIcon={<DeleteIcon />}
                >
                  カートを空にする
                </Button>
                <span>コイン残高:{Constants.CURRENCY_UNIT_LEFT_COIN} {coin.toLocaleString()}</span>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handlePurchase}
                  size="large"
                >
                  購入する (¥{getTotalPrice().toLocaleString()})
                </Button>
              </Box>
            </>
          ) : (
            <Box sx={{ textAlign: 'center', py: 4 }}>
              <Typography variant="body1" color="text.secondary">
                カートに商品がありません
              </Typography>
            </Box>
          )}
        </DialogContent>
      </Dialog>

      <Toolbar /> {/* スペーサー */}

      <Container sx={{ py: 4 }}>
        <Grid container spacing={4}>
          {filteredProducts.map((product) => (
            <Grid item key={product.id} xs={12} sm={6} md={4}>
              <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ position: 'relative' }}>
                  <CardMedia
                    component="img"
                    height="200"
                    image={product.image}
                    alt={product.name}
                  />
                  <Chip
                    label={ratings[product.rating].label}
                    color={ratings[product.rating].color}
                    sx={{
                      position: 'absolute',
                      top: 8,
                      right: 8,
                    }}
                  />
                </Box>
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography gutterBottom variant="h5" component="h2">
                    {product.name}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    {product.description}
                  </Typography>
                  <Typography variant="h6" color="primary">
                    ¥{product.price.toLocaleString()}
                  </Typography>
                </CardContent>
                <CardActions sx={{ justifyContent: 'center', pb: 2 }}>
                  {cart[product.id] ? (
                    <ButtonGroup variant="outlined" size="small">
                      <IconButton onClick={() => removeFromCart(product.id)}>
                        <RemoveIcon />
                      </IconButton>
                      <Button disabled>
                        {cart[product.id]}
                      </Button>
                      <IconButton onClick={() => addToCart(product.id)}>
                        <AddIcon />
                      </IconButton>
                    </ButtonGroup>
                  ) : (
                    <Button
                      variant="contained"
                      onClick={() => addToCart(product.id)}
                      startIcon={<AddIcon />}
                    >
                      カートに追加
                    </Button>
                  )}
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* 年齢確認ダイアログ */}
      <Dialog
        open={showWarning}
        onClose={handleWarningCancel}
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningIcon color="warning" />
          年齢確認
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {selectedRating === 'R18' ? 
              '18歳以上のコンテンツを含むカテゴリーを表示します。あなたは18歳以上ですか？' :
              'R-18Gカテゴリーには過激な表現が含まれる可能性があります。表示してもよろしいですか？'
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleWarningCancel}>キャンセル</Button>
          <Button onClick={handleWarningConfirm} variant="contained" color="warning">
            確認して表示
          </Button>
        </DialogActions>
      </Dialog>

      {/* カテゴリー設定ドロワー */}
      <Drawer
        anchor="right"
        open={settingsOpen}
        onClose={() => setSettingsOpen(false)}
      >
        <Box sx={{ width: 300, p: 2 }}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            カテゴリー設定
          </Typography>
          <Divider sx={{ mb: 2 }} />
          <List>
            {Object.entries(categories).filter(([key]) => key !== 'all').map(([key, label]) => (
              <ListItem key={key}>
                <ListItemIcon>
                  {blockedCategories.includes(key) ? <BlockIcon color="error" /> : null}
                </ListItemIcon>
                <ListItemText primary={label} />
                <Switch
                  edge="end"
                  checked={!blockedCategories.includes(key)}
                  onChange={() => handleBlockCategory(key)}
                />
              </ListItem>
            ))}
          </List>
          <Typography variant="h6" sx={{ mb: 2 }}>
            年齢設定
          </Typography>
          <FormControl size="small" sx={{ minWidth: 120, backgroundColor: 'white', borderRadius: 1 }}>
              <Select
                value={selectedRating}
                onChange={handleRatingChange}
              >
                {Object.entries(ratings).map(([key, { label }]) => (
                  <MenuItem key={key} value={key}>{label}</MenuItem>
                ))}
              </Select>
          </FormControl>
        </Box>
      </Drawer>
    </>
  );
};

export default Shop;